import * as React from "react";
import {Component} from "react";
import { connect } from "react-redux";

import Payments from "../../screens/Payments";

import {getPayments, PaypageSelected} from "./action";

class PaymentsContainer extends Component {
  render() {
    return <Payments 
    getPayments={this.props.getPayments}
    PaypageSelected={this.props.PaypageSelected}
    paymentsList={this.props.paymentsList}
    paymentsListCount={this.props.paymentsListCount}
    />;
  }
}
function bindAction(dispatch) {
  return {
    getPayments: (val) => {
      dispatch(getPayments(val));
    },
    PaypageSelected:(val)=>{
      dispatch(PaypageSelected(val));
    },
   };
}

const mapStateToProps = (state) => {
  return {
    paymentsList: state.PaymentReducer.paymentsList,
    paymentsListCount:state.PaymentReducer.paymentsListCount,
  };
};

export default connect(mapStateToProps, bindAction)(PaymentsContainer);
